import { PMPartsAndProcedure } from '../../types/pmTypes';
import { Btn, BtnIconOnly, IconClose } from '../ui';

interface EditHistoryEntry {
    editedBy: string;
    editedByUserId: string;
    editedAt: string;
    changes: Record<string, { from: any; to: any }>;
}

interface EditHistoryModalProps {
    isOpen: boolean;
    onClose: () => void;
    item: PMPartsAndProcedure;
}

const fieldLabels: Record<string, string> = {
    category: 'Category',
    manufacturer: 'Manufacturer',
    partNumber: 'Item #',
    itemName: 'Description',
    vendorId: 'Vendor ID',
    vendorName: 'Vendor',
    unitOfMeasure: 'Unit of Measure',
    itemType: 'Item Type',
    price: 'Price',
};

export const EditHistoryModal = ({ isOpen, onClose, item }: EditHistoryModalProps) => {
    if (!isOpen) return null;

    let history: EditHistoryEntry[] = [];
    try {
        history = item.editHistory ? JSON.parse(item.editHistory) : [];
    } catch { history = []; }

    // Show most recent first
    const sorted = [...history].reverse();

    return (
        <div className="cr-modal-overlay" onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="cr-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600 }}>
                <div className="cr-modal-header">
                    <h2 className="cr-modal-title">Edit History</h2>
                    <BtnIconOnly size="sm" icon={<IconClose />} ariaLabel="Close" onClick={onClose} />
                </div>
                <div className="cr-modal-body" style={{ maxHeight: 450, overflowY: 'auto' }}>
                    <div style={{ marginBottom: 12, fontSize: 13, color: '#64748b' }}>
                        <strong>{item.itemName || item.category || 'Service Item'}</strong>
                        {item.partNumber && <span> &middot; #{item.partNumber}</span>}
                    </div>

                    {sorted.length === 0 ? (
                        <div style={{ padding: 24, textAlign: 'center', color: '#94a3b8' }}>
                            No edit history recorded for this item.
                        </div>
                    ) : (
                        <div className="cr-edit-history-list">
                            {sorted.map((entry, idx) => (
                                <div key={idx} className="cr-edit-history-entry">
                                    <div className="cr-edit-history-header">
                                        <span className="cr-edit-history-user">{entry.editedBy || 'Unknown'}</span>
                                        <span className="cr-edit-history-date">
                                            {new Date(entry.editedAt).toLocaleDateString()}{' '}
                                            {new Date(entry.editedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                        </span>
                                    </div>
                                    <div className="cr-edit-history-changes">
                                        {Object.entries(entry.changes).map(([field, { from, to }]) => (
                                            <div key={field} className="cr-edit-history-change">
                                                <span className="cr-edit-history-field">{fieldLabels[field] || field}:</span>
                                                <span className="cr-edit-history-from">{from ?? '(empty)'}</span>
                                                <span className="cr-edit-history-arrow">{'\u2192'}</span>
                                                <span className="cr-edit-history-to">{to ?? '(empty)'}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className="cr-modal-footer">
                    <Btn variant="secondary-outlined" buttonText="Close" buttonOnClick={onClose} />
                </div>
            </div>
        </div>
    );
};
